export default {
  chartContainer: {
    display: 'flex',
    minHeight: 350,
    paddingBottom: 16,
    paddingTop: 16,
  },
};
